import React from 'react';
import { Flexbox, BasicPage, BasicPageHeader, Panel } from '@sonika-se/ui-kit/components';
import PublicHolidaysPanel from '~/panels/PublicHolidaysPanel';
import PublicHolidaysApiPanel from '~/panels/PublicHolidaysApiPanel';
export const ToolsPage = () => {
    return (<>
      <BasicPage width="large">
        <BasicPageHeader title="Verktyg"/>
        <Panel>
          <Flexbox direction="row" gap="small" justify="equal">
            <PublicHolidaysPanel />
            <PublicHolidaysApiPanel />
          </Flexbox>
        </Panel>
      </BasicPage>
    </>);
};
